import React from "react";
import {useMaillerForm} from "./useMaillerForm";
import MaillerFormView from "./MaillerFormView";

export default function MaillerForm({action, mails, document, bdd, langue}) {
	const logic = useMaillerForm({action, mails, document, bdd, langue});

	return (
		<MaillerFormView
			{...logic}
			action={action}
			mails={mails}
			document={document}
		/>
	);
}
